/* eslint-disable @typescript-eslint/ban-types */
import React from 'react';
import { Cell } from 'react-table';

import { formatNumberCompact } from '@trqk/utils';

interface Props<D extends object> {
    cell: Cell<D>;
}

/**
 * Formats a number into a compact string. For example, given the input `1000`, the output would be
 * '1K'.
 * @param param
 */
export function CompactNumberCell<D extends object>({
    cell,
}: Props<D>): JSX.Element {
    const { value } = cell;

    return <>{formatNumberCompact(value)}</>;
}
